import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1a021f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Files = _resolveComponent("Files")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: _normalizeClass(['list', _ctx.size])
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enclosureList, (file, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [
          (!_ctx.isImage(file))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "pdf",
                href: file.fileUrl,
                target: "_blank"
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Files)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_2, _toDisplayString(file.name), 1)
              ], 8, _hoisted_1))
            : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                class: "image",
                fit: "cover",
                src: _ctx.$filters.ossUrl(file.fileUrl),
                "preview-src-list": _ctx.previewImg
              }, null, 8, ["src", "preview-src-list"]))
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["class"]))
}